<template>
  <div class="zoom-image-section">
    <figure class="zoom" :style="`background-image: url(${this.signedUrl})`">
      <img
        :src="signedUrl"
        :alt="src"
        :class="classes"
        :style="styles"
        class="image-responsive"
        v-if="urlReceiveFlag"
      />
      <img
        :class="classes"
        :src="newSrcImage"
        class="image-responsive"
        :alt="src"
        :style="styles"
        v-else
      />
    </figure>
  </div>
</template>
<script>
export default {
  props: [
    "src",
    "styles",
    "classes",
    "signedUrl",
    "urlReceiveFlag",
    "newSrcImage",
  ],
  data() {
    return {
      isHover: false,
    };
  },
  mounted() {
    document
      .querySelector("figure")
      .addEventListener("mouseleave", this.zoomOut);
    document.querySelector("figure").addEventListener("mousemove", this.zoom);
  },
  methods: {
    zoom(e) {
      this.isHover = true;
      var zoomer = e.currentTarget;
      var offsetX, offsetY, x, y;

      e.offsetX ? (offsetX = e.offsetX) : (offsetX = e.touches[0].pageX);
      e.offsetY ? (offsetY = e.offsetY) : (offsetX = e.touches[0].pageX);
      x = (offsetX / zoomer.offsetWidth) * 100;
      y = (offsetY / zoomer.offsetHeight) * 100;
      zoomer.style.backgroundPosition = x + "% " + y + "%";
    },
    zoomOut() {
      this.isHover = false;
    },
  },
};
</script>
<style lang="scss">
.zoom-image-section {
  width: 600px;
  margin-left: auto;
  margin-right: auto;
  figure.zoom {
    & img:hover {
      opacity: 0;
    }
    img {
      transition: opacity 0.5s;
      display: block;
      width: 100%;
    }
    background-position: 50% 50%;
    position: relative;
    width: 70%;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
    cursor: zoom-in;
  }
}
</style>